import * as React from 'react';
import { useState } from 'react';
import * as Countup from 'react-countup';
import ReactPlaceholder from 'react-placeholder';
import Waypoint from 'react-waypoint';
import styled from 'styled-components';

interface IProps {
  count?: string;
  loading?: boolean;
  text?: string;
  className?: string;
}

export const ExplainItem: React.SFC<IProps> = props => {
  const [hasStarted, setStart] = useState(false);
  const setStarted = () => setStart(true);
  const finalChar = (props.count || '0').substr(-1);
  let suffix = '';
  if (isNaN(parseInt(finalChar, 10))) {
    suffix = finalChar;
  }
  const formatNumber = (n: number) =>
    n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + suffix;
  return (
    <Container className={props.className}>
      <CountContainer>
        <Waypoint onEnter={setStarted}>
          <div>
            <ReactPlaceholder
              showLoadingAnimation={true}
              rows={1}
              ready={!props.loading}
            >
              <Countup
                formattingFn={formatNumber}
                end={parseInt(
                  hasStarted && props.count ? props.count : '0',
                  10
                )}
              />
              {/* {parseInt(, 10)} */}
            </ReactPlaceholder>
          </div>
        </Waypoint>
      </CountContainer>
      <Text>
        <ReactPlaceholder
          showLoadingAnimation={true}
          rows={1}
          ready={!props.loading}
        >
          {props.text || ''}
        </ReactPlaceholder>
      </Text>
    </Container>
  );
};

export default ExplainItem;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const CountContainer = styled.div`
  width: 100px;
  padding: 10px;
  font-size: 34px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 700;
`;

const Text = styled.div`
  font-size: 16px;
  width: 100%;
  text-align: center;
`;



// WEBPACK FOOTER //
// ./src/components/ExplainItem/ExplainItem.tsx